export interface CnpjApiData {
  cnpj?: string;
  razao_social?: string;
  nome_fantasia?: string;
  data_inicio_atividade?: string;
  descricao_situacao_cadastral?: string;
  cnae_fiscal_descricao?: string;
  logradouro?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  municipio?: string;
  codigo_municipio_ibge?: number;
  uf?: string;
  cep?: string;
  ddd_telefone_1?: string;
}

export interface CnpjResult {
  data?: CnpjApiData;
  error?: string;
}

// Consulta dados públicos da empresa pelo CNPJ usando a BrasilAPI (gratuita, sem chave).
export const getCnpjData = async (cnpj: string): Promise<CnpjResult> => {
  const digits = (cnpj || "").replace(/\D/g, "");
  if (digits.length !== 14) {
    return { error: "Informe um CNPJ válido (14 dígitos)." };
  }
  try {
    const response = await fetch(
      `https://brasilapi.com.br/api/cnpj/v1/${digits}`
    );
    if (!response.ok) {
      return { error: "CNPJ não encontrado na base da Receita." };
    }
    const data = (await response.json()) as CnpjApiData;
    return { data };
  } catch (error) {
    console.log("error", error);
    return { error: "Erro ao consultar o CNPJ. Tente novamente." };
  }
};
